// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../node_modules/rescript/lib/es6/list.js";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as UrlUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";

function getRoute(url) {
  var match = url.path;
  if (!match) {
    return ;
  }
  if (match.hd !== "dashboard") {
    return ;
  }
  var match$1 = match.tl;
  if (!match$1) {
    return ;
  }
  if (match$1.hd !== "support") {
    return ;
  }
  var match$2 = match$1.tl;
  if (!match$2) {
    return ;
  }
  if (match$2.hd !== "error") {
    return ;
  }
  if (match$2.tl) {
    return ;
  }
  var urlParams = UrlUtils$Catalyst.getURLParams(url.search);
  var languageCode = Belt_Option.mapWithDefault(Js_dict.get(urlParams, "language"), "en", (function (x) {
          if (List.mem(x, {
                  hd: "en",
                  tl: {
                    hd: "hi",
                    tl: {
                      hd: "kn",
                      tl: {
                        hd: "ta",
                        tl: {
                          hd: "te",
                          tl: {
                            hd: "mr",
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                })) {
            return x;
          } else {
            return "en";
          }
        }));
  var language;
  switch (languageCode) {
    case "en" :
        language = /* English */0;
        break;
    case "hi" :
        language = /* Hindi */1;
        break;
    case "kn" :
        language = /* Kannada */2;
        break;
    case "mr" :
        language = /* Marathi */5;
        break;
    case "ta" :
        language = /* Tamil */3;
        break;
    case "te" :
        language = /* Telugu */4;
        break;
    default:
      throw {
            RE_EXN_ID: "Match_failure",
            _1: [
              "SupportRouteManager.res",
              18,
              47
            ],
            Error: new Error()
          };
  }
  return {
          TAG: /* SupportView */5,
          _0: language
        };
}

var RouteManager = {
  getRoute: getRoute
};

export {
  RouteManager ,
  
}
/* No side effect */
